var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"page-view-container"},[_c('el-main',{staticClass:"scrollbar"},[_vm._t("default"),(!_vm.noRoute)?_c('route-view',{attrs:{"height":"100%"}}):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }